export default "__VITE_ASSET__CrUc30s5__"